import { Typography } from '@mui/material';
import Icon from '@src/main/ui/components/common/Icon/Icon';
import { type FC } from 'react';
import styles from './Loading.module.scss';

const Loading: FC = () => (
  <div className={styles.loading}>
    <div className={styles.loading__logo}>
      <Icon iconId="iberia" />
    </div>
    <Typography className={styles.loading__title} variant="h4">
      Dashboards Portal
    </Typography>
  </div>
);

export default Loading;
